var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-checkbox-group',{on:{"change":_vm.handleChecked},model:{value:(_vm.array),callback:function ($$v) {_vm.array=$$v},expression:"array"}},_vm._l((_vm.checkboxes),function(c){return _c('el-checkbox',{key:c.value,attrs:{"label":c.value}},[_vm._v(_vm._s(c.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }